import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

// Apply persisted theme before first render to avoid flash
const stored = localStorage.getItem('pbf-portal-theme');
const isDark = stored ? (JSON.parse(stored)?.state?.isDark ?? true) : true;
if (isDark) {
  document.documentElement.classList.add('dark');
}

// Set document title based on environment
const appEnv = import.meta.env.VITE_APP_ENV;
document.title = appEnv ? `PBF Operator Portal - ${appEnv}` : 'PBF Operator Portal';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
